<template>
   <nav
      :class="[
         'top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg',
         { 'nav-scrolled': isScrolled },
      ]"
   >
      <div
         class="container px-4 mx-auto flex flex-wrap items-center justify-between"
      >
         <div
            class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
         >
            <router-link
               class="text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap"
               to="/"
            >
               Advanced Measurements
            </router-link>
            <button
               class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
               type="button"
               v-on:click="setNavbarOpen"
            >
               <i class="text-white fas fa-bars"></i>
            </button>
         </div>
         <div
            class="lg:flex flex-grow items-center"
            :class="[
               navbarOpen ? 'block rounded shadow-lg bg-gray-800' : 'hidden',
            ]"
         >
            <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/wavedata"
                  >
                     <i
                        class="text-white fas fa-cloud text-lg leading-lg mr-2"
                     ></i>
                     WaveData
                  </router-link>
               </li>
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/waveedge"
                  >
                     <i
                        class="text-white fas fa-microchip text-lg leading-lg mr-2"
                     ></i>
                     WaveEdge
                  </router-link>
               </li>
               <li class="flex items-center">
                  <dvcommand-dropdown />
               </li>
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/fracsupport"
                  >
                     <i
                        class="text-white fas fa-phone text-lg leading-lg mr-2"
                     ></i>
                     Frac Support
                  </router-link>
               </li>
            </ul>
         </div>
      </div>
   </nav>
</template>

<script>
import DVCommandDropdown from "@/components/Dropdowns/DVCommandDropdown.vue";

export default {
   components: {
      "dvcommand-dropdown": DVCommandDropdown,
   },
   data() {
      return {
         navbarOpen: false,
         isScrolled: false,
      };
   },
   methods: {
      setNavbarOpen: function () {
         this.navbarOpen = !this.navbarOpen;
      },
      handleScroll() {
         this.isScrolled = window.scrollY > 0;
      },
   },
   mounted() {
      window.addEventListener("scroll", this.handleScroll);
   },
   beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
   },
};
</script>

<style>
nav {
   transition: background-color 0.3s ease;
   background-color: rgba(51, 51, 51, 0);
}

nav.nav-scrolled {
   background-color: rgba(51, 51, 51, 0.65);
}
</style>
